import { render, staticRenderFns } from "./WitModal.vue?vue&type=template&id=fc453580&"
import script from "./WitModal.vue?vue&type=script&lang=js&"
export * from "./WitModal.vue?vue&type=script&lang=js&"
import style0 from "./WitModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports